import { Injectable } from "@angular/core";
import { ServiceBase } from "./service-base";
import { HttpClient } from "@angular/common/http";
import { ISelectionBox } from "../model/ISelectionBox";
import { catchError } from "rxjs/operators";
import { IApplicantCourse } from "../model/IApplicantCourse";
import { IApplicantCourseGradeTypeItem } from "../model/IApplicantCourseGradeTypeItem";
import { IApplicationType } from "../model/IApplicationType";
import { CookieService } from "ngx-cookie-service";
import { CookiesLocalService } from "./cookies-local.service";

@Injectable({
  providedIn: "root",
})
export class UtilService extends ServiceBase {
  getApplicationDocumentTypes() {
    let url = this.baseUrl + "/api/Util/GetApplicationDocumentTypes";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getSystemConfig() {
    let url = this.baseUrl + "/api/Util/GetSystemConfiguration";
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  constructor(
    http: HttpClient,
    cookieService: CookieService,
    cookieLocal: CookiesLocalService
  ) {
    super(http, cookieService, cookieLocal);
  }

  getApplicantCourses() {
    let url = this.baseUrl + "/api/Admission/GetApplicantCourses";
    return this.http
      .get<IApplicantCourse[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicationTypes() {
    let url = this.baseUrl + "/api/Admission/GetApplicationTypes";
    return this.http
      .get<IApplicationType[]>(url, this.getHttpHeaderOptionWithNoAuth())
      .pipe(catchError(this.errorHandler));
  }
  getApplicantExaminationTypes() {
    let url = this.baseUrl + "/api/Admission/GetApplicantExaminationTypes";
    return this.http
      .get<any>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getExamPeriods() {
    let url = this.baseUrl + "/api/Admission/GetExamPeriods";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicantCourseGradeTypeItems() {
    let url = this.baseUrl + "/api/Admission/GetApplicantCourseGradeTypeItems";
    return this.http
      .get<IApplicantCourseGradeTypeItem[]>(
        url,
        this.getHttpHeaderOptionWithToken()
      )
      .pipe(catchError(this.errorHandler));
  }
  getRegions() {
    let url = this.baseUrl + "/api/Util/GetRegions";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getCountries() {
    let url = this.baseUrl + "/api/Util/GetCountries";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getGenders() {
    let url = this.baseUrl + "/api/Util/GetGenders";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getApplicationModes() {
    let url = this.baseUrl + "/api/Admission/GetApplicationModes";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getMaritalStatuses() {
    let url = this.baseUrl + "/api/Util/GetMaritalStatuses";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getRelationships() {
    let url = this.baseUrl + "/api/Util/GetRelationships";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getTitles() {
    let url = this.baseUrl + "/api/Util/GetTitles";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getDenominations() {
    let url = this.baseUrl + "/api/Util/GetDenominations";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getCampus() {
    let url = this.baseUrl + "/api/Util/GetCampus";
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getProgrammes() {
    let url = this.baseUrl + "/api/Util/GetProgrammesForAdmissions";
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getUnderGraduateProgrammesForAdmissionByCampusId(
    campusId,
    isPostgraduateStudent = false
  ) {
    let url =
      this.baseUrl +
      `/api/Util/GetUnderGraduateProgrammesForAdmissionByCampusId?campusId=${campusId}`;

    if (isPostgraduateStudent) {
      url =
        this.baseUrl +
        `/api/Util/GetPostGraduateProgrammesForAdmissionByCampusId?campusId=${campusId}`;
    }

    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getPostgraduateStudentTypes() {
    let url = this.baseUrl + "/api/Util/GetPostgraduateStudentTypes";
    return this.http
      .get<any[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getDisabilities() {
    let url = this.baseUrl + "/api/Util/GetDisabilities";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getEthnicGroups() {
    let url = this.baseUrl + "/api/Util/GetEthnicGroups";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getMarketingMethods() {
    let url = this.baseUrl + "/api/Util/GetMarketingMethods";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getInstitutions() {
    let url = this.baseUrl + "/api/Util/GetInstitutions";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getHalls() {
    let url = this.baseUrl + "/api/Util/GetHalls";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getOccupations() {
    let url = this.baseUrl + "/api/Util/GetOccupations";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getReligions() {
    let url = this.baseUrl + "/api/Util/GetReligions";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getYears() {
    let url = this.baseUrl + "/api/Util/GetYears";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }
  getMonths() {
    let url = this.baseUrl + "/api/Util/GetMonths";
    return this.http
      .get<ISelectionBox[]>(url, this.getHttpHeaderOptionWithToken())
      .pipe(catchError(this.errorHandler));
  }

  getAdmissionList() {
    let url = this.baseUrl + `/api/Util/GetAdmissionBatch`;
    return this.http.get<any>(url).pipe(catchError(this.errorHandler));
  }
}
